import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const PencilIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="outline/pencil"><path id="Icon" d="M18.7176 8.11163L8.11099 18.7182L3.86835 20.1324L5.28256 15.8898L15.8892 5.2832L18.0105 3.16188C18.401 2.77136 19.0342 2.77136 19.4247 3.16188L20.8389 4.5761C21.2294 4.96662 21.2294 5.59979 20.8389 5.99031L18.7176 8.11163ZM15.8892 5.2832L18.7176 8.11163" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PencilIcon;